import styled from 'styled-components';

const Wrapper = styled.div`
  overflow: hidden;
  display: flex;
  min-width: calc(33.33% - 5px);
  height: 90px;
  border-radius: 10px;
  .skeleton-box{
    width: 100%;
    height: 100%;
  }
`;

const CompanyWidgetSmallSkeleton = function CompanyWidgetSmallSkeleton() {
  return (
    <Wrapper>
      <span className="skeleton-box" />
    </Wrapper>
  );
};

export default CompanyWidgetSmallSkeleton;
